import { Flex, Label, Table } from '@fareye/ui';
import {
  startCase,
  isEmpty
} from '@fareye/utils';
import { useTranslation, dateFormatter } from '@fareye/common';
import { getTableColumns } from '@fareye/common'
import React, { useEffect, useState } from 'react';
import { tripTabsBackground, modeBackground } from '@fareye/configs'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content',
  },
  downloadIcon: {
    marginLeft: '8px',
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px',
  },
}

export const formatters: any = {
  startCase,
  dateFormatterTZ: dateFormatter
};

export const HEADER_INFLECTION = {
  headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
}

export const DocumentsListing = ({
  id,
  data
}: any) => {

  const { t } = useTranslation()  
  const documentColumns = [
    {
      key: "driverLicenceUrl",
      label: "Driver Licence",
    },
    {
      key: "vehicleRcUrl",
      label: "Vehicle RC",
    },
  ];

  const selectedColumn = React.useMemo(() => {
      return getTableColumns(documentColumns, {
        t,
        queryParams: {}
      })
    }, [])

  const displayData = isEmpty(data)
  ? []
  : [
      {
        driverLicenceUrl: data?.driverLicenceUrl || "",
        vehicleRcUrl: data?.vehicleRcUrl || "",
      },
    ];

  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Flex justifyContentSpaceBetween>
          <Label
            style={{ fontSize: '16px', fontWeight: 600, marginTop: '6px' }}
          >
            Document
          </Label>
        </Flex>
      </Flex>
      {!isEmpty(displayData) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            totalElements={displayData.length}
            sortable={false}
            showTotalCount={false}
            showPagination={false}
            data={displayData}
            columns={selectedColumn}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  );
};
